var React = require('react');

function Dots (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Union_1","data-name":"Union 1","d":"M0,21.853a2.3,2.3,0,0,1,2.143-2.429,2.3,2.3,0,0,1,2.142,2.429,2.3,2.3,0,0,1-2.142,2.429A2.3,2.3,0,0,1,0,21.853ZM0,12.14A2.3,2.3,0,0,1,2.143,9.713,2.3,2.3,0,0,1,4.285,12.14a2.3,2.3,0,0,1-2.142,2.429A2.3,2.3,0,0,1,0,12.14ZM0,2.429A2.3,2.3,0,0,1,2.143,0,2.3,2.3,0,0,1,4.285,2.429,2.3,2.3,0,0,1,2.143,4.856,2.3,2.3,0,0,1,0,2.429Z","fill":"#232323"}));
}

Dots.defaultProps = {"width":"4.285","height":"24.282","viewBox":"0 0 4.285 24.282"};

module.exports = Dots;

Dots.default = Dots;
